module.exports = __webpack_public_path__ + "img/Group8.6bc6962f.png";